/*
 * @Author: your name
 * @Date: 2021-11-23 18:07:56
 * @LastEditTime: 2021-11-24 23:16:41
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /static-pc/src/store/module/common/action.js
 */
import * as Types from '../../mutations-types'
import * as CommonService from '@/services/commonService'
export default {
  getDicOptionList ({commit, state}) {
    if (state.channelList.length || state.departmentList.length) return Promise.resolve(true)
    return CommonService.getDicOptionList().then(res=>{
      commit(Types.GET_DIC_OPTION_LIST,res.data)
      return Promise.resolve(res)
    },rea=>{
      return Promise.reject(rea)
    })
  },
  getAreaList ({commit, state}) {
    if (state.areaList.length) return Promise.resolve(true)
    return CommonService.getAreaList().then(res=>{
      commit(Types.GET_AREA_LIST,res.data)
      return Promise.resolve(res)
    },rea=>{
      return Promise.reject(rea)
    })
  }
}